module.exports = __webpack_public_path__ + "static/media/Kraftriket logo.350c5193.png";